
import { Vue, Component } from 'vue-property-decorator';
import { Button } from 'vant';
import SyEditor from '@/components/SyEditor.vue';

Vue.use(Button);

@Component({
  components: {
    SyEditor,
  },
})
export default class RichTextEditor extends Vue {
  getContent(type: 'text' | 'richtext') {
    if (type === 'text') {
      console.log((this.$refs.syEditor as SyEditor).getPlainText());
    } else {
      console.log((this.$refs.syEditor as SyEditor).content);
    }
  }
}
